module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="left_course" style="border-left:4px solid <%= course.get(\'activityColor\')%>">\n    <span class="studioname"><%= course.get(\'studioName\')%></span>\n    <span class="activityname"><%= course.get(\'activityName\')%></span>\n    <span class="coachname"><%= course.get(\'coachName\') %></span>\n</div>\n<div class="right_course">\n    <% if (hour) { %>\n        <span>&nbsp;</span>\n        <span class="timer"><%= course.get(\'beginHour\') %></span>\n        <span>&nbsp;</span>\n    <% } else { %>\n        <% if (course.get(\'minutesPassed\') == 0) { %>\n            <span>Dans</span>\n            <span class="timer">un</span>\n            <span>instant</span>\n        <% } else { %>\n            <span>Depuis</span>\n            <span class="timer"><%= course.get(\'minutesPassed\')%></span>\n            <span>minute<% if (course.get(\'minutesPassed\') > 1) { %>s<% } %></span>\n        <% } %>\n    <% } %>\n</div>\n<div class="bottom_course">\n    <p class="course_desc"><% if (course.get(\'activityDesc\')) { %><%= course.get(\'activityDesc\')%> <% } %></p>\n    <div class="image_activity" style="background-image: url(<%= course.get(\'activityImageUrl\')%> )">\n    </div>\n</div>\n\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="left_course" style="border-left:4px solid ', escape((__stack.lineno = 1, course.get("activityColor"))), '">\n    <span class="studioname">', escape((__stack.lineno = 2, course.get("studioName"))), '</span>\n    <span class="activityname">', escape((__stack.lineno = 3, course.get("activityName"))), '</span>\n    <span class="coachname">', escape((__stack.lineno = 4, course.get("coachName"))), '</span>\n</div>\n<div class="right_course">\n    ');
                __stack.lineno = 7;
                if (hour) {
                    buf.push('\n        <span>&nbsp;</span>\n        <span class="timer">', escape((__stack.lineno = 9, course.get("beginHour"))), "</span>\n        <span>&nbsp;</span>\n    ");
                    __stack.lineno = 11;
                } else {
                    buf.push("\n        ");
                    __stack.lineno = 12;
                    if (course.get("minutesPassed") == 0) {
                        buf.push('\n            <span>Dans</span>\n            <span class="timer">un</span>\n            <span>instant</span>\n        ');
                        __stack.lineno = 16;
                    } else {
                        buf.push('\n            <span>Depuis</span>\n            <span class="timer">', escape((__stack.lineno = 18, course.get("minutesPassed"))), "</span>\n            <span>minute");
                        __stack.lineno = 19;
                        if (course.get("minutesPassed") > 1) {
                            buf.push("s");
                            __stack.lineno = 19;
                        }
                        buf.push("</span>\n        ");
                        __stack.lineno = 20;
                    }
                    buf.push("\n    ");
                    __stack.lineno = 21;
                }
                buf.push('\n</div>\n<div class="bottom_course">\n    <p class="course_desc">');
                __stack.lineno = 24;
                if (course.get("activityDesc")) {
                    buf.push("", escape((__stack.lineno = 24, course.get("activityDesc"))), " ");
                    __stack.lineno = 24;
                }
                buf.push('</p>\n    <div class="image_activity" style="background-image: url(', escape((__stack.lineno = 25, course.get("activityImageUrl"))), ' )">\n    </div>\n</div>\n\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1664531962-2.1.11/node_modules/ejs-compiled-loader!./src/templates/popup_footer_activity.ejs
// module id = 143
// module chunks = 0